module.exports = __webpack_public_path__ + "assets/0103_IFOK_WIM_MARKER_yellow_publikation_je.b865efd0.svg";